const html = require('choo/html')
const { Button } = require('./elements.js')
const { stop, list, record, zipFile, link, shuffle } = require('./icons.js')

function ShareButtons(state, emit) {
  return html`
    <ul id="share-button" class="row size-big space-default align-center">
      ${state.isMobile ? '' : html`
        <li class="size-big square">
          ${Button(
    { onClick: () => emit('exportsamplepack') },
    html`<span>${zipFile}</span>`
  )}
        </li>
      `}
      <!-- <li class="size-big square">
        ${Button(
    {
      onClick: () => {
        if (state.agreeWithTerms) {
          emit('sharesamplepack')
        } else {
          emit('startsharing')
        }
      }
    },
    html`<span>${link}</span>`
  )}
      </li> -->
    </ul>
  `
}



module.exports = function SampleBoard(state, emit) {
  function SampleListItem(sampleId, i) {
    const fileEntry = state.samples.find(f => f.id === sampleId)
    const sample = state.samples.find(s => s.id === sampleId)

    let background = i % 2 === 0 ? '#f6f5f8' : '#FFFFFF'
    function onMouseDown(e) {
      e.preventDefault()
      emit('select-sample-from-board', i)
    }
    function onMouseOver() {
      if (state.draggingSampleOnBoard !== null) {
        emit('drag-sample-over-board', i)
      }
    }
    let color = sample.file.state === 'started' ? 'color: #2ab573;' : ''
    let index = state.shuffle ? '': `${i+1}. `
      return html`
      <li class="size-small grid-button" style="background: ${background}; margin-top: 0; margin-bottom: 0; height:2vw;">
      <div  style="display:inline-block; width:85%; height:100%;">
        <span onmouseover=${onMouseOver} onmousedown=${onMouseDown} class="description" style="font-size:1.5vw; ${color}" >
           ${index}${sample ? sample.name : 'empty'}
        </span>
      </div>

    <div style="display:inline-block; float:right;" class="size-small"
      >
            <svg class="flat-icon"
            onmousedown= ${() => emit('playsample', sampleId)}
             xmlns="http://www.w3.org/2000/svg" width=".65em" height = ".65em" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"></path>
             
            </svg>
            <svg class="flat-icon"
            onmousedown= ${() => emit('removesample', sampleId)}
            xmlns="http://www.w3.org/2000/svg" width=".65em" height=".65em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path fill="currentColor" d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/>
            </svg>

    </div>  
    `
  }


  let samplePackHidden = 'visible'
  if (state.isRecordingOpen) {
    samplePackHidden = 'hidden'
  }

  const openLibraryButton = Button(
    {
      onClick: () => emit('togglesoundlibrary'),
      active: state.isSoundLibraryOpen
    },
    html`<span>${list}</span>`
  )
  const stopAllSoundsButton = Button(
    { onClick: () => emit('stopallsounds') },
    html`<span>${stop}</span>`
  )
  const openRecordingButton = Button(
    {
      onClick: () => emit('togglerecording'),
      active: state.isRecordingOpen,
    },
    html`<span>${record}</span>`
  )

  const toggleShuffleButton = Button(
    {
      onClick: () => emit('toggleshuffle'),
      active: state.shuffle,
    },
    html`<span>${shuffle}</span>`

  )
  const dropping = state.selectedSample || state.dragging
  const droppingClass = dropping ? 'dropme' : ''

  return html`
    <div id="sampler-board" class="contour space-tight ">
      <div id="space-button" style = "margin-left: 33%; margin-right: 33%;" class="${droppingClass} size-biggest square">
        ${Button(
          {
            color: 'yellow',
            onMouseDown: () => document.body.dispatchEvent(new KeyboardEvent('keydown', { key: ' ' })),
          },
          html`
            <span class="description" id="press-space">
              SPACE
            </span>
          `
          )}
      </div>
      <div style="overflow:hidden; border-radius: 1vw; height:50%;">
        <ul id="grid" style="height:100%; background: #f6f5f8; overflow-y: scroll;" class="space-default">
          ${state.sampleBoard.map(SampleListItem)}
        </ul>
        </div>
        <ul id="sampler-controls" class="row size-big space-default align-center">
          <li id="open-library" class="size-big square">
            ${openLibraryButton}
          </li>
          <li id="stop-sounds" class="size-big square">
            ${stopAllSoundsButton}
          </li>
          ${state.isMobile ? '' : html`
            <li id="open-recording" class="size-big square">
              ${openRecordingButton}
            </li>
          `}
          <li id="shuffle" class="size-big square">
            ${toggleShuffleButton}
          </li>
        </ul>
          
      </div>
      ${state.customSamplePack ? ShareButtons(state, emit) : null}
  `
}
